import React from 'react'

import { Grid, Card, CardContent, CardMedia, Typography, Divider } from '@material-ui/core'
import Image from '../../../../../Image/Image.js'
import Button from '../../../../../UI/Button/Button'
import icons from '../../../../../../icons.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AssignStatus from '../../../../Assignment/CommonContent/AssignStatus/AssignStatus.js'
import Checkbox from '../../../../../UI/Forms/Checkbox/Checkbox'

function AppraisalCard({
  appraisalType,
  recordData,
  editButtonClicked,
  editButtonDisabled,
  recordSelected,
  checked,
  checkDisabled
}) {
  let card = null
  if (appraisalType?.label.includes('APT01')) {
    card = <CorporateCard recordData={recordData} />
  } else {
    card = <IndividualCard recordData={recordData} />
  }

  return (
    <Grid item container xl={2} lg={4} md={4} sm={6} xs={12} justify={'center'}>
      <Card style={{ textAlign: 'left', width: '100%' }}>
        <CardContent>
          <Grid container direction={'row'} wrap={'nowrap'} alignItems={'stretch'}>
            <Grid container item alignItems={'center'} style={{ width: 'auto ' }}>
              <CardMedia>
                <Image
                  style={{
                    minWidth: 100,
                    minHeight: 100
                  }}
                  src={recordData?.emp?.image_path}
                  imgAlt={recordData.full_name}
                />
              </CardMedia>
            </Grid>
            {card}
            <Grid
              container
              item
              xs={2}
              direction={'row'}
              alignContent={'space-between'}
              alignItems={'stretch'}
              justify={'center'}>
              <Grid item>
                <Checkbox
                  checked={checked}
                  size={'small'}
                  changed={recordSelected}
                  disabled={checkDisabled}
                />
              </Grid>
              <Grid item>
                <Button
                  clicked={editButtonClicked}
                  disabled={editButtonDisabled}
                  variant={'text'}
                  style={{
                    minWidth: 30,
                    minHeight: 30,
                    width: 30,
                    height: 30,
                    borderRadius: '50%'
                  }}>
                  <FontAwesomeIcon icon={icons.faEdit} />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <AssignStatus structures={recordData?.structures} />
      </Card>
    </Grid>
  )
}

const CorporateCard = ({ recordData }) => {
  return (
    <CardContent style={{ textAlign: 'left', width: '100%' }}>
      <Typography variant={'h6'}>{recordData?.org?.org_name}</Typography>
      <Typography variant={'subtitle1'}>{recordData?.org?.org_code}</Typography>
      <Typography variant={'body2'}>{recordData?.level?.level_name}</Typography>
    </CardContent>
  )
}

const IndividualCard = ({ recordData }) => {
  return (
    <CardContent style={{ textAlign: 'left', width: '100%' }}>
      <Typography variant={'h6'}>{recordData?.emp?.full_name}</Typography>
      <Typography variant={'subtitle1'}>{recordData?.emp?.emp_code}</Typography>
      <Typography variant={'body2'}>{recordData?.organization?.org_name}</Typography>
      <Typography variant={'body2'}>{recordData?.level?.level_name}</Typography>
      <Typography variant={'body2'}>{recordData?.position?.position_name}</Typography>
    </CardContent>
  )
}

export default AppraisalCard
